import React, { useEffect, useState } from "react";

function PriceInput(props: any) {
  const {
    id,
    value,
    required,
    disabled,
    readonly,
    onChange,
    placeholder,
    schema,
    formContext,
  } = props;

  const { element } = formContext || {};
  const [inputValue, setInputValue] = useState<number>(Number(value) || 0);
  const [isNegative, setIsNegative] = useState<boolean>(false);

  const toNumber = (v: any) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  useEffect(() => {
    const base = toNumber(element?.base_price);
    const discount = toNumber(element?.discount);
    const diff = base - discount;

    if (diff < 0) {
      setIsNegative(true);
      setInputValue(0);
      onChange?.(0);
    } else {
      setIsNegative(false);
      setInputValue(diff);
      onChange?.(diff);
    }
  }, [element?.base_price, element?.discount]);

  useEffect(() => {
    if (value !== undefined) {
      setInputValue(toNumber(value));
    }
  }, [value]);

  return (
    <div>
      <input
        id={id}
        className="form-control"
        type={schema?.type || "number"}
        value={inputValue}
        step={schema?.multipleOf || "0.01"}
        min={0}
        required={required}
        disabled={disabled}
        readOnly={readonly ?? true} // por defecto es calculado
        placeholder={placeholder || "Precio final"}
        style={{
          color: isNegative ? "red" : undefined,
          fontWeight: isNegative ? "bold" : undefined,
        }}
      />
      {isNegative && (
        <small style={{ color: "red" }}>
          ⚠️ El precio se muestra como 0 porque la diferencia entre el precio base y el descuento no puede ser negativa.
        </small>
      )}
    </div>
  );
}

export default PriceInput;
